import {
  Popover,
  PopoverButton,
  PopoverPanel,
  useClose,
} from "@headlessui/react";
import { getMappings } from "../store/workspaceSlice";
import { columnDataTypes, showConfirmDelete } from "../helpers";
import {
  deleteInputColumn,
  deleteOutputColumn,
  clearInputColumnForm,
} from "../store/workspaceSlice";
import { useDispatch, useSelector } from "react-redux";
import { setEditStateData } from "../store/workspaceSlice";
const RulesListandDetails = ({ column, index, type = "input" }) => {
  const dispatch = useDispatch();
  const currentMaps = useSelector(getMappings);
  let close = useClose();
  const deleteData = (colChar, type) => {
    const additionalWarning =
      "If this column is being used in any mappings, you will need to update those mappings too.";
    if (type === "input") {
      showConfirmDelete(
        colChar,
        () => {
          dispatch(deleteInputColumn(colChar));
          dispatch(clearInputColumnForm());
          setEditStateData({
            data: {},
            type: "inputColumnForm",
            editMode: false,
          });
        },
        close,
        currentMaps.length && additionalWarning, // show warning if there is any mapping present
      );
    } else if (type === "output") {
      showConfirmDelete(
        colChar,
        () => {
          dispatch(deleteOutputColumn(colChar));
        },
        close,
        currentMaps.length && additionalWarning, // show warning if there is any mapping present
      );
    }
  };

  return (
    <Popover key={index}>
      <PopoverButton
        onPointerDown={(e) => e.stopPropagation()} // Prevents drag from interfering with the popover
        className=" w-full flex justify-between items-center p-2 bg-white border rounded-md shadow-sm hover:bg-gray-200 hover:cursor-pointer outline-none focus:border-red-500"
      >
        <span className="font-medium text-gray-700">
          {/* handeling type of rule */}
          {type === "input" || type === "output" ? "Col" : " Rule Name"}:
          {column.inColChr || column.outColChr || column.ruleName}
        </span>
        <span className="text-sm text-gray-500">
          Type: {columnDataTypes?.[column?.inColDT || column.outColDT]}
        </span>
      </PopoverButton>
      <PopoverPanel transition anchor="left" className="rounded-lg">
        <div className="p-3 w-300 bg-gray-500">
          <div className="flex flex-col  divide-y divide-dashed rounded-lg py-2 px-3 transition hover:bg-white/5 font-semibold text-white">
            {column?.outputColumnHeader && (
              <div className="grid grid-cols-2 gap-4">
                <span>Column Header</span>
                <span className="text-white/70">
                  {column.outputColumnHeader}
                </span>
              </div>
            )}
            {/* will work for both input and output column */}
            {(column?.inColChr || column.outColChr) && (
              <div className="grid grid-cols-2 gap-4">
                <span>Column Name</span>
                <span className="text-white/70">
                  {column?.inColChr || column.outColChr}
                </span>
              </div>
            )}
            {/* Show decoded data type */}
            {(column?.inColDT || column?.outColDT) && (
              <div className="grid grid-cols-2 gap-4">
                <span>Data Type</span>
                <span className="text-white/70">
                  {columnDataTypes?.[column?.inColDT || column.outColDT]}
                </span>
              </div>
            )}

            {/* Show rule input column */}
            {column?.inputColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Input Column </span>
                <span className="text-white/70">{column?.inputColumn}</span>
              </div>
            )}

            {/* date user defined data */}
            {column?.userDefinedData && (
              <div className="grid grid-cols-2 gap-4">
                <span>Custom Data </span>
                <span className="text-white/70">{column?.userDefinedData}</span>
              </div>
            )}
            {/* Clone Column */}
            {column?.cloneColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Clone Column </span>
                <span className="text-white/70">{column?.cloneColumn}</span>
              </div>
            )}

            {/* date mask */}
            {(column?.dateMask || column?.mask) && (
              <div className="grid grid-cols-2 gap-4">
                <span>Mask </span>
                <span className="text-white/70">{column?.mask}</span>
              </div>
            )}
            {/* date source column details */}
            {column?.dateCol && (
              <div className="grid grid-cols-2 gap-4">
                <span>Get date from column </span>
                <span className="text-white/70">{column?.dateCol}</span>
              </div>
            )}

            {/* Input Date Format */}
            {column?.inputDateFormat && (
              <div className="grid grid-cols-2 gap-4">
                <span>Input Date Format </span>
                <span className="text-white/70">{column?.inputDateFormat}</span>
              </div>
            )}

            {/* Convert to Date Format */}
            {column?.toDateFormat && (
              <div className="grid grid-cols-2 gap-4">
                <span>To Date Format </span>
                <span className="text-white/70">{column?.toDateFormat}</span>
              </div>
            )}
            {/* Make data absolute */}
            {column?.makeColumnAbsolute && (
              <div className="grid grid-cols-2 gap-4">
                <span>Make Column Absolute</span>
                <span className="text-white/70">{`${
                  column?.makeColumnAbsolute && "True"
                }`}</span>
              </div>
            )}
            {/* Convert to Date Format */}
            {column?.makeItInteger && (
              <div className="grid grid-cols-2 gap-4">
                <span>Convert to Integer</span>
                <span className="text-white/70">{`${
                  column?.makeItInteger && "True"
                }`}</span>
              </div>
            )}

            {/* Input Column Account number*/}
            {column?.inColAccountNo && (
              <div className="grid grid-cols-2 gap-4">
                <span>Account Number </span>
                <span className="text-white/70">{column?.inColAccountNo}</span>
              </div>
            )}
            {/* Input Column DC code*/}
            {column?.inColDcCode && (
              <div className="grid grid-cols-2 gap-4">
                <span>DC Code </span>
                <span className="text-white/70">{column?.inColDcCode}</span>
              </div>
            )}

            {/* Input Column Exchange Rate*/}
            {column?.inColExchangeRate && (
              <div className="grid grid-cols-2 gap-4">
                <span>Exchange Rate </span>
                <span className="text-white/70">
                  {column?.inColExchangeRate}
                </span>
              </div>
            )}

            {/* Add number of days in new column */}
            {column?.dateDays && (
              <div className="grid grid-cols-2 gap-4">
                <span>Add number of days </span>
                <span className="text-white/70">{column?.dateDays}</span>
              </div>
            )}

            {/* Contact Name for this column  */}
            {column?.inColContactName && (
              <div className="grid grid-cols-2 gap-4">
                <span>Contact Name </span>
                <span className="text-white/70">
                  {column?.inColContactName}
                </span>
              </div>
            )}

            {/* Input Column Description   */}
            {column?.inColDesc && (
              <div className="grid grid-cols-2 gap-4">
                <span>Description </span>
                <span className="text-white/70">{column?.inColDesc}</span>
              </div>
            )}

            {/* Input Column character code   */}
            {column?.inColCharCode && (
              <div className="grid grid-cols-2 gap-4">
                <span>Input Column CH Code </span>
                <span className="text-white/70">{column?.inColCharCode}</span>
              </div>
            )}

            {/* Input Column due date   */}
            {column?.inColDueDate && (
              <div className="grid grid-cols-2 gap-4">
                <span>Due Date </span>
                <span className="text-white/70">
                  {parseInt(column?.inColDueDate, 10) // Check for valid integer days or display same string
                    ? `${column?.inColDueDate} Days`
                    : column?.inColDueDate}
                </span>
              </div>
            )}
          </div>
        </div>
        {/* show list of replace words */}
        <div className=" bg-gray-200 flex">
          {column?.replacingData?.length > 0 && (
            <div className="w-full">
              <h1 className="font-normal bg-gray-400 text-center">
                Replace Data
              </h1>
              <ul className="list-disc list-inside p-2 max-h-24 overflow-y-auto">
                {column.replacingData.map((data, index) => (
                  <li
                    key={index}
                    className="flex w-full items-center bg-gray-100 p-1 my-1 rounded"
                  >
                    <span>
                      '{data.cellValue}'{" -> "}'{data.replaceWith}'
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="p-2 bg-gray-400 flex justify-end">
          <button
            onClick={() =>
              deleteData(column.inColChr || column.outColChr, type)
            }
            className="px-2 py-1 bg-red-400 hover:bg-red-500 rounded-md text-white font-medium active:bg-red-700 transition-all duration-200"
          >
            Delete
          </button>
          <button
            onClick={() => {
              let section = column.inColChr
                ? "inputColumnForm"
                : "outputColumnForm";

              dispatch(
                setEditStateData({
                  data: { ...column },
                  type: section,
                  editMode: true,
                }),
              );
            }}
            className="px-2 py-1 bg-green-500 hover:bg-green-700 rounded-md text-white font-medium active:bg-gray-500 transition-all duration-200 ml-2"
          >
            Edit
          </button>
        </div>
      </PopoverPanel>
    </Popover>
  );
};

export default RulesListandDetails;
